import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Card, Col, Container, Modal, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { SiImessage } from "react-icons/si";
import { useLocation, useNavigate } from "react-router-dom";
import Pagination from "../../Pagination";
import ChatComponent from "../ChatComponent";
import DashboardLayout from "./DashboardLayout ";
import GlobalHRSettings from "./GlobalHRSettings";
import './HrDashboard.css';
import Slider from "./Slider";
import ViewCandidateDetails from "./ViewCandidateDetails";
const ViewApplications = () => {
  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const { userEmail, userName, jobId, jobTitle, currentJobApplicationPage, currentJobApplicationPageSize, companyName } = location.state || {};
  const [applications, setApplications] = useState([]);
  const [resumeTypes, setResumeTypes] = useState({});
  const [filterStatus, setFilterStatus] = useState('all');
  const [fileNames, setfileNames] = useState({});
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [totalPages, setTotalPages] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null); // Track the currently sorted column
  const [sortOrder, setSortOrder] = useState(' '); // Track the sort order (asc or desc)
  const [loading, setLoading] = useState(true);
  const currentApplicationPage = location.state?.currentApplicationPage || 0;
  const [page, setPage] = useState(currentApplicationPage);
  const currentApplicationPageSize = location.state?.currentApplicationPageSize || 6;
  const [pageSize, setPageSize] = useState(currentApplicationPageSize);
  const [isLoading, setIsLoading] = useState(true);
  const [isResumeBrief, setIsResumeBrief] = useState(false);
  const [viewCandidate, setViewCandidate] = useState(false);
  const isLastPage = page === totalPages - 1;
  const isPageSizeDisabled = isLastPage;

  useEffect(() => {
    if (filterStatus === 'all' && !(fromDate && toDate)) {
      fetchApplications();
    } else if (filterStatus || (fromDate && toDate)) {
      handleSelect(filterStatus, fromDate, toDate);
    }
  }, [jobId, page, pageSize, sortedColumn, sortOrder, fromDate, toDate]);

  useEffect(() => {

    const storedPage = localStorage.getItem('currentViewPage');
    if (storedPage !== null) {
      const parsedPage = Number(storedPage);
      if (parsedPage < totalPages) {
        setPage(parsedPage);


      }
    }


  }, [totalPages]);


  const state1 = location.state || {};


  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0); // Reset page when page size change
  };

  const handleFilterChange = async (e) => {
    setFilterStatus(e.target.value);
    handleSelect(e.target.value, fromDate, toDate);

  };
  useEffect(() => {
    if (location.state?.currentApplicationPage === undefined && location.state?.currentApplicationPageSize) {
      setPage(0);
      setPageSize(6);
    }
  }, [location.state?.currentApplicationPage, location.state?.currentApplicationPageSize]);


  const handleSelect = async (filterStatus, fromDate, toDate) => {
    setLoading(true);
    try {
      const params = {
        jobId: jobId,
        filterStatus: filterStatus || "all", // default
        page: page,
        size: pageSize
      }
      if (fromDate && toDate) {
        params.fromDate = fromDate;
        params.toDate = toDate;
      }
      const endpoint = fromDate && toDate
        ? `${BASE_API_URL}/getFilterApplicationsWithDateByJobIdWithpagination`
        : `${BASE_API_URL}/getFilterApplicationsByJobIdWithpagination`;

      const response = await axios.get(endpoint, { params });

      setApplications(response.data.content || []);
      fetchResumeTypes(response.data.content || []);
      fetchCandidateDetails(response.data.content || []);
      setTotalPages(response.data.totalPages);
      setLoading(false);
    } catch (error) {
    }
  };
  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1)); // Ensure selectedPage is within range
    setPage(selectedPage);
    localStorage.setItem('currentViewPage', selectedPage);
    // Store the page number in localStorage
  };

  const fetchApplications = async () => {
    setLoading(true);
    try {
      const params = {
        jobId: jobId,
        page: page,
        size: pageSize,
        sortBy: sortedColumn,
        sortOrder: sortOrder
      };

      const response = await axios.get(`${BASE_API_URL}/getApplicationsByJobIdWithPagination`, { params });
      setApplications(response.data.content || []);
      fetchResumeTypes(response.data.content || []);
      fetchCandidateDetails(response.data.content || []);
      setTotalPages(response.data.totalPages);
      setLoading(false);
    } catch (error) {
    }
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    handleSelect(filterStatus, date, toDate);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
    handleSelect(filterStatus, fromDate, date);
  };
  useEffect(() => {
    fetchApplications();
  }, [jobId, page, pageSize, sortedColumn, sortOrder]);

  useEffect(() => {
    localStorage.removeItem('currentViewPage', page);
  }, [page]);

  const handleSort = (column) => {
    let order = 'asc';
    if (sortedColumn === column) {
      order = sortOrder === 'asc' ? 'desc' : 'asc';
    }
    setSortedColumn(column);
    setSortOrder(order);

  };

  const updateStatus = async (applicationId, newStatus) => {

    try {
      await axios.put(`${BASE_API_URL}/updateApplicationStatus?applicationId=${applicationId}&newStatus=${newStatus}&hrEmail=${userEmail}`);
      fetchApplications();
    } catch (error) {
    }
  };
  const [unreadMessages, setUnreadMessages] = useState([]); // State to track unread messages

  useEffect(() => {
    const fetchStatuses = async () => {

      const unread = {}; // Initialize unread messages state

      for (const application of applications) {
        try {

          const countUnread = await fetchCountUnreadMessage(application.applicationId);

          unread[application.applicationId] = countUnread;

        } catch (error) {
        }
      }
      setUnreadMessages(unread); // Set unread messages state
    };
    fetchStatuses();
  }, [applications]);

  const fetchResumeTypes = async (applications) => {
    setIsLoading(true);
    const types = {};
    const fileNames = {};
    for (const application of applications) {
      try {
        const response = await axios.get(`${BASE_API_URL}/getResumeByApplicationId?resumeId=${application.resumeId}`);
        types[application.resumeId] = response.data.fileType;
        fileNames[application.resumeId] = response.data.fileName;

      } catch (error) {
      }
    }

    setResumeTypes(types);
    setfileNames(fileNames);
    setIsLoading(false);
  };

  const fetchCountUnreadMessage = async (applicationId) => {
    try {
      const response = await axios.get(`${BASE_API_URL}/fetchCountUnreadMessageForHRByApplicationId?applicationId=${applicationId}`);
      return response.data;
    } catch (error) {
    }
  }

  // Change renderResumeComponent to accept the application object
  const renderResumeComponent = (application) => {
    const resumeId = application.resumeId;
    const fileType = resumeTypes[resumeId];
    const fileName = fileNames[resumeId];
    // Helper to update status if needed
    const maybeUpdateStatus = () => {
      if (application.applicationStatus === 'Not Seen') {
        updateStatus(application.applicationId, 'Seen'); // Capital 'S'
      }

    };
    if (fileType === 'file') {
      return (
        <Button className="btn-sm" variant="primary" onClick={() => { handleDownload(resumeId, fileName, application); maybeUpdateStatus(); }}>Download</Button>
      );
    } else if (fileType === 'link') {
      return (
        <a href={fileName} target="_blank" rel="noopener noreferrer" onClick={() => { updateViewCount(resumeId, "link"); maybeUpdateStatus(); }}>Click here</a>
      );
    } else if (fileType === 'brief') {
      return (
        <Button className="btn-sm" variant="primary" onClick={() => {
          updateViewCount(resumeId, "brief");
          openPopup(fileName);
          maybeUpdateStatus();
        }}>Open Brief</Button>
      );
    } else {
      return null; // Handle other file types as needed
    }
  };


  const updateViewCount = async (resumeId, action) => {
    try {
      await axios.post(`${BASE_API_URL}/resume-increment-view`, null, {
        params: {
          resumeId: resumeId,
          action: action,
          companyName: companyName,
          jobId: jobId,
        },
      });
    } catch (error) {
    }
  };


  const [showMessage, setShowMessage] = useState(false);
  const [showBriefSettings, setShowBriefSettings] = useState(false);
  const openPopup = (fileName) => {
    setShowMessage(fileName);
    setShowBriefSettings(!showBriefSettings);
  };

  // Update handleDownload to accept application and remove status update logic from here (handled in renderResumeComponent)
  const handleDownload = async (resumeId, fileName, application) => {
    const action = "download"
    try {
      // Increment view count
      await axios.post(`${BASE_API_URL}/resume-increment-view`, null, {
        params: {
          resumeId: resumeId,
          action: action, // Action type
          companyName: companyName,
          jobId: jobId,
        },
      });

      const response = await axios.get(`${BASE_API_URL}/downloadResume?resumeId=${resumeId}`, {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
    }
  };

  const [candidateName, setCandidateName] = useState({});
  const [candidateEmail, setCandidateEmail] = useState({});

  const fetchCandidateDetails = async (applications) => {
    const candidateNames = {};
    const candidateEmails = {};
    for (const application of applications) {
      try {
        const res = await axios.get(`${BASE_API_URL}/getUserName`, {
          params: { userId: application.candidateId }
        });
        candidateNames[application.candidateId] = res.data.userName;
        candidateEmails[application.candidateId] = res.data.userEmail;
      } catch (error) {
      }
    }
    setCandidateName(candidateNames);
    setCandidateEmail(candidateEmails);
  }

  const navigate = useNavigate();

  const handleBack = () => {
    const state1 = location.state || {};
    navigate(-1);
    // navigate('/hr-dashboard/hr-applications', { state: { userEmail, userName, jobId, currentJobApplicationPage, currentJobApplicationPageSize } })

  };




  // State to track if the ChatComponent is open
  const [isChatOpen, setIsChatOpen] = useState(false);

  const [chatData, setChatData] = useState({
    applicationId: null,
    candidateId: null,
    hrId: null,
  });

  // Function to handle chat icon click
  const toggleChat = async (application) => {
    // Set the chat data for the clicked application
    // Mark messages as read
    axios.put(`${BASE_API_URL}/markCandidateMessagesAsRead?applicationId=${application.applicationId}`);
    const unread = {}; // Initialize unread messages state
    try {

      const countUnread = fetchCountUnreadMessage(application.applicationId);

      unread[application.applicationId] = countUnread;
      const response = await axios.get(`${BASE_API_URL}/getResumeByApplicationId?resumeId=${application.resumeId}`);

      // Assuming response.data is an object with the fileType field
      const fileType = response.data.fileType; // Correctly access fileType from response data


      if (fileType === 'brief') {
        setIsResumeBrief(true);  // Set the state to true if fileType is 'brief'
      } else {
        setIsResumeBrief(false); // Set the state to false if fileType is not 'brief'
      }

    } catch (error) {
    }
    setUnreadMessages(unread); // Set unread messages state
    setChatData({
      applicationId: application.applicationId,
      candidateId: application.candidateId,
      hrId: application.hrId,
    });
    // Toggle the visibility of the ChatComponent
    setIsChatOpen(!isChatOpen);
  };

  const [selectedCandidateId, setSelectedCandidateId] = useState(null);
  const [selectedResumeId, setSelectedResumeId] = useState(null);
  const [selectedAppliedOn, setSelectedAppliedOn] = useState(null);  // New state for appliedOn

  const handleCandidateClick = (candidateId, resumeId, appliedOn) => {
    setSelectedCandidateId(candidateId);
    setSelectedResumeId(resumeId);
    setSelectedAppliedOn(appliedOn);   // Set appliedOn here
    setViewCandidate(true);
  };

  return (
    <DashboardLayout>
      <div className="main-content">
        <Row className="d-flex justify-content-between align-items-center" style={{ marginBottom: '20px' }}>
          <Col xs="auto">
            <h2>
              {/* {applications.length === 0 ? (
                <div style={{ textAlign: 'center' }}>There are no applicants for this job application</div>
              ) : ( */}
              <div className="text-start">Applicants for {jobTitle}</div>
              {/* )} */}
            </h2>

          </Col>

          <Col xs="auto">
            <GlobalHRSettings />
          </Col>
        </Row>
        <Row className="mb-4 m-3">
          {/* Filter by Status */}
          <Col xs={12} md={6} lg={4}>
            <label
              htmlFor="status"
              className="form-label"
              style={{ color: '#6c5b7b' }} // Purple color for the label
            >
              Filter by Status:
            </label>
            <select
              id="status"
              onChange={handleFilterChange}
              value={filterStatus}
              className="form-select form-select-sm fs-5"
              style={{
                borderColor: '#6c5b7b',
                borderRadius: '6px',
                height: '40px', // Match the height of the select
                width: '100%', // Full width
                padding: '0 10px', // Add horizontal padding for text
              }}            >
              <option value="all">All</option>
              <option value="Shortlisted">Shortlisted</option>
              <option value="Not Seen">Not Seen</option>
              <option value="Seen">Seen</option>
              <option value="Not Shortlisted">Not Shortlisted</option>
            </select>
          </Col>

          {/* Filter by Date */}
          <Col xs={12} md={6} lg={4}>
            <label
              htmlFor="date"
              className="form-label"
              style={{ color: '#6c5b7b' }} // Purple color for the label
            >
              Filter by Date:
            </label>
            <div className="date-filter d-flex flex-column flex-md-row gap-3">
              <div className="date-input-group d-flex flex-row gap-2">
                <div className="d-flex flex-column flex-md-row">
                  <label
                    htmlFor="fromDate"
                    className="form-label mb-1"
                    style={{ color: '#6c5b7b' }} // Purple color for the label
                  >
                    From:
                  </label>
                  <input
                    type="date"
                    id="fromDate"
                    value={fromDate}
                    onChange={(e) => handleFromDateChange(e.target.value)}
                    className="form-control form-control-sm fs-7"
                    style={{
                      maxWidth: '150px',
                      borderColor: '#6c5b7b',
                      boxShadow: 'none',
                      width: '100%', // Full width on mobile
                    }}
                  />
                </div>
                <div className="d-flex flex-column flex-md-row">
                  <label
                    htmlFor="toDate"
                    className="form-label mb-1"
                    style={{ color: '#6c5b7b' }} // Purple color for the label
                  >
                    To:
                  </label>
                  <input
                    type="date"
                    id="toDate"
                    value={toDate}
                    onChange={(e) => handleToDateChange(e.target.value)}
                    className="form-control form-control-sm fs-7"
                    style={{
                      maxWidth: '150px',
                      borderColor: '#6c5b7b',
                      boxShadow: 'none',
                      width: '100%', // Full width on mobile
                    }}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Row style={{ marginLeft: '10px' }}>
          <p>
            <b>Action:(&nbsp;
              <span className="circle gray"></span>Not Seen,&nbsp;
              <span className="circle blue"></span>Seen,&nbsp;
              <span className="circle red"></span>Not Shortlisted,&nbsp;
              <span className="circle green"></span>Shortlisted)
            </b>
          </p>
        </Row>


        <div>
          {loading ? (
            <div className="d-flex justify-content-center align-items-center">
              <div className="spinner-bubble spinner-bubble-primary m-5" />
              <span>Loading...</span>
            </div>
          ) : applications.length > 0 ? (
            <>
              <Container fluid className="my-4">
                <Row>
                  {/* Left Side: Table */}
                  <Col md={viewCandidate ? 6 : 12}>
                    <Card>
                      <div className="table-details-list table-wrapper">
                        <Table hover responsive>
                          <thead>
                            <tr>
                              {/* <th
                                scope="col"
                                onClick={() => handleSort('jobRole')}
                                style={{ cursor: 'pointer' }}
                              >
                                Job Title{' '}
                                <span>
                                  <span
                                    style={{
                                      color:
                                        sortedColumn === 'jobRole' && sortOrder === 'asc'
                                          ? 'black'
                                          : 'gray',
                                    }}
                                  >
                                    ↑
                                  </span>{' '}
                                  <span
                                    style={{
                                      color:
                                        sortedColumn === 'jobRole' && sortOrder === 'desc'
                                          ? 'black'
                                          : 'gray',
                                    }}
                                  >
                                    ↓
                                  </span>
                                </span>
                              </th> */}
                              <th scope="col">Candidate Name</th>
                              {/* <th scope="col">Candidate Email</th> */}
                              <th scope="col">Resume ID</th>
                              {/* <th
                                scope="col"
                                onClick={() => handleSort('appliedOn')}
                                style={{ cursor: 'pointer' }}
                              >
                                Date{' '}
                                <span>
                                  <span
                                    style={{
                                      color:
                                        sortedColumn === 'appliedOn' && sortOrder === 'asc'
                                          ? 'black'
                                          : 'gray',
                                    }}
                                  >
                                    ↑
                                  </span>{' '}
                                  <span
                                    style={{
                                      color:
                                        sortedColumn === 'appliedOn' && sortOrder === 'desc'
                                          ? 'black'
                                          : 'gray',
                                    }}
                                  >
                                    ↓
                                  </span>
                                </span>
                              </th> */}
                              <th scope="col" className="text-center">Action</th>
                              <th scope="col" className="text-center">Chat</th>
                              <th scope="col" className="text-center">View Details</th>
                            </tr>
                          </thead>

                          <tbody>
                            {applications.map((application) => (
                              <tr key={application.applicationId}>
                                {/* <td>{application.jobRole}</td> */}
                                <td>{application.candidateName ? application.candidateName : candidateName[application.candidateId] || 'N/A'}</td>
                                {/* <td>{application.candidateEmail ? application.candidateEmail : candidateEmail[application.candidateId] || 'N/A'}</td> */}
                                <td>{isLoading ? 'Loading...' : renderResumeComponent(application)}</td>
                                {/* <td>{application.appliedOn}</td> */}
                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                  <div className="d-flex justify-content-center align-items-center">
                                    <Slider
                                      initialStatus={application.applicationStatus}
                                      onChangeStatus={(newStatus) => updateStatus(application.applicationId, newStatus)}
                                    />
                                  </div>
                                </td>
                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                  <div style={{ position: 'relative', display: 'inline-block' }}>
                                    {unreadMessages[application.applicationId] > 0 && (
                                      <span
                                        style={{
                                          position: 'absolute',
                                          top: '-5px',
                                          right: '-15px',
                                          backgroundColor: 'red',
                                          color: 'white',
                                          borderRadius: '50%',
                                          width: '20px',
                                          height: '20px',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          fontSize: '12px',
                                          fontWeight: 'bold',
                                          zIndex: 1,
                                        }}
                                      >
                                        {unreadMessages[application.applicationId]}
                                      </span>
                                    )}
                                    <SiImessage
                                      size={25}
                                      onClick={() => toggleChat(application)}
                                      style={{ color: 'green', cursor: 'pointer' }}
                                    />
                                  </div>
                                </td>
                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                  <Button
                                    size="sm"
                                    variant="outline-primary"
                                    onClick={() => {
                                      if (resumeTypes[application.resumeId] === 'brief') {
                                        openPopup(fileNames[application.resumeId]);  // Show brief message popup
                                      } else {
                                        handleCandidateClick(
                                          application.candidateId,
                                          application.resumeId,
                                          application.appliedOn
                                        );
                                      }
                                    }}
                                  >
                                    View
                                  </Button>
                                </td>


                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>

                      {/* Pagination */}
                      <Pagination
                        page={page}
                        pageSize={pageSize}
                        totalPages={totalPages}
                        handlePageSizeChange={handlePageSizeChange}
                        isPageSizeDisabled={isPageSizeDisabled}
                        handlePageClick={handlePageClick}
                      />
                    </Card>
                  </Col>

                  {/* Right Side: Candidate Details (4 columns) */}
                  {viewCandidate && (
                    <Col md={6}>
                      <ViewCandidateDetails
                        candidateId={selectedCandidateId}
                        resumeId={selectedResumeId}
                        appliedOn={selectedAppliedOn}   // Pass appliedOn here
                        setViewCandidate={setViewCandidate}
                      />
                    </Col>
                  )}
                </Row>
              </Container>
            </>
          ) : (
            <section className="no-jobs-message">
              <div style={{ textAlign: 'center' }}>There are no applicants for this job application</div>
            </section>
          )}
          <Button variant='primary' onClick={handleBack} style={{ width: '70px', marginLeft: '10px', marginTop: '10px' }}>Back</Button>
        </div>

        {showBriefSettings && (
          <Modal show={showBriefSettings} onHide={() => setShowBriefSettings(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Brief Resume</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ overflowY: 'auto' }}>{showMessage}</Modal.Body>
          </Modal>
        )}


        {/* Conditionally render the ChatComponent */}
        {isChatOpen && (
          <ChatComponent
            applicationId={chatData.applicationId}
            candidateId={chatData.candidateId}
            hrId={chatData.hrId}
            userType='HR'
            setIsChatOpen={setIsChatOpen}
            isResumeBrief={isResumeBrief}
          />
        )}
      </div>
    </DashboardLayout>
  );
};

export default ViewApplications;

